import React, { Component } from 'react';
import logo from './logo.svg';
import Main from './Main.js';
import PriceCalc from './PriceCalc.js'
import './App.css';
import { SnackbarProvider } from 'notistack';
import {Elements, StripeProvider} from 'react-stripe-elements';
import PricingRouter from './PricingRouter.js';

// import './bootstrap.css'
const session = localStorage.getItem("session")
console.log("session")
console.log(session)
const ses = JSON.parse(session)
class App extends Component {
  constructor(props) {
  super(props);
    this.state = {
     
      loading: false,
      session: ses || {status:false},
      
    }
    //binded methods
    this.setSession = this.setSession.bind(this)
  }

  setSession(session){
    this.setState({
      session:session
    })
  }




  render() {
    return (




      <SnackbarProvider
        hideIconVariant
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        maxSnack={3}>

        <StripeProvider apiKey="pk_test_HHyXdB4uERpu6YD83hMRZ3bo00qfQ2QIZj">

          <PricingRouter session={this.state.session} setSession={this.setSession}/>
        </StripeProvider>

      </SnackbarProvider>





    );
  }
}

export default App;
